package com.routexk.quiz.ui.sections.footer

import androidx.compose.runtime.Composable
import com.routexk.quiz.ui.sections.footer.components.FooterLink
import com.routexk.quiz.ui.sections.footer.components.HorizontalDivider
import com.routexk.quiz.ui.sections.footer.components.SocialIcon
import com.routexk.quiz.ui.theme.AppColors
import com.routexk.quiz.ui.utils.Constants
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.*

@Composable
internal fun FooterMobile() {
    val colorMode = ColorMode.current
    val colors = AppColors.getColors(colorMode)

    Column(
        Modifier
            .fillMaxWidth()
            .gap(2.cssRem),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        Column(
            Modifier.gap(0.5.cssRem),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SpanText(
                "CONTACT:",
                Modifier
                    .fontSize(0.75.cssRem)
                    .fontWeight(FontWeight.Bold)
                    .color(colors.textPrimary)
                    .letterSpacing(0.1.em)
            )
            SpanText(
                Constants.PHONE,
                Modifier
                    .fontSize(0.9.cssRem)
                    .color(colors.textSecondary)
            )
            SpanText(
                Constants.CONTACT_NAME,
                Modifier
                    .fontSize(0.9.cssRem)
                    .color(colors.textSecondary)
            )
        }

        Column(
            Modifier.gap(0.5.cssRem),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            FooterLink("About", Constants.SECTION_ABOUT)
            FooterLink("Services", Constants.SECTION_SERVICES)
            FooterLink("Projects", Constants.SECTION_PROJECTS)
            FooterLink("Contact", Constants.SECTION_CONTACTS)
        }

        Row(
            Modifier.gap(1.cssRem)
        ) {
            SocialIcon("📷", Constants.INSTAGRAM_URL, "Instagram")
            SocialIcon("👥", Constants.FACEBOOK_URL, "Facebook")
            SocialIcon("🐦", Constants.TWITTER_URL, "Twitter")
            SocialIcon("💼", Constants.LINKEDIN_URL, "LinkedIn")
        }

        Column(
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SpanText(
                Constants.COPYRIGHT,
                Modifier
                    .fontSize(0.8.cssRem)
                    .color(colors.textTertiary)
            )
            SpanText(
                "All rights reserved.",
                Modifier
                    .fontSize(0.8.cssRem)
                    .color(colors.textTertiary)
            )
        }

        HorizontalDivider()

        FooterLink("Privacy Policy", "#privacy")
    }
}
